import type { TripPaymentStatus } from "@shared/schema";

const STATUS_CONFIG: Record<TripPaymentStatus, { label: string; className: string }> = {
  no_invoices: {
    label: "No Invoices",
    className: "bg-muted text-muted-foreground",
  },
  unpaid: {
    label: "Unpaid",
    className: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
  },
  partially_paid: {
    label: "Partially Paid",
    className: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  },
  fully_paid: {
    label: "Fully Paid",
    className: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
  },
};

export function TripPaymentStatusBadge({ status }: { status: TripPaymentStatus }) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.no_invoices;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
}
